import styled from "@emotion/styled";

export const ReadOnlyNotebookContainer = styled.div`
  pointer-events: none;
`;
